import {
    BUSINESS_AREAS_ERROR_ACTION_TYPE,
    BUSINESS_AREAS_FETCH_ACTION_TYPE,
    BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE,
    SERVICES_ERROR_ACTION_TYPE,
    SERVICES_FETCH_ACTION_TYPE,
    SERVICES_FETCH_SUCCESS_ACTION_TYPE,
    SERVICES_RESET_ACTION_TYPE,
    ServicesAction
} from 'actions/services/ServicesActionsTypes';
import { ServicesState, ServiceStatus } from 'reducers/services/ServicesState';
import { Reducer } from 'redux';

const initialState: ServicesState = {
    services: [],
    businessAreas: [],
    status: ServiceStatus.Initial,
    loading: true
};

export const servicesReducer: Reducer<ServicesState, ServicesAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case SERVICES_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case SERVICES_FETCH_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: ServiceStatus.Fetching
            };
        case SERVICES_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: ServiceStatus.FetchSuccess,
                services: action.payload.services
            };
        case BUSINESS_AREAS_FETCH_ACTION_TYPE:
            return {
                ...state
            };
        case BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                businessAreas: action.payload.areas
            };
        case BUSINESS_AREAS_ERROR_ACTION_TYPE:
            return {
                ...state
            };
        case SERVICES_ERROR_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: ServiceStatus.Error
            };
        default:
            return state;
    }
};
